export type ParsedOccOptionSymbol = {
  optionType: 'C' | 'P' | '?';
  strike: number | null;
  expiry: string | null;
};

/** Best-effort OCC parse, e.g. `F     260717P00013000`. */
export function parseOccOptionSymbol(symbol: string): ParsedOccOptionSymbol {
  const raw = (symbol ?? '').trim();
  const out: ParsedOccOptionSymbol = { optionType: '?', strike: null, expiry: null };
  if (raw.length < 15) return out;
  const body = raw.length > 6 ? raw.slice(6).trim() : raw;
  const m = body.match(/^(\d{6})([CP])(\d+)$/);
  if (!m) return out;
  const yymmdd = m[1];
  const cp = m[2];
  const strikeRaw = m[3];
  const yy = Number(yymmdd.slice(0, 2));
  const mm = Number(yymmdd.slice(2, 4));
  const dd = Number(yymmdd.slice(4, 6));
  if (Number.isFinite(yy) && Number.isFinite(mm) && Number.isFinite(dd)) {
    const year = yy < 70 ? 2000 + yy : 1900 + yy;
    out.expiry = `${year.toString().padStart(4, '0')}-${mm.toString().padStart(2, '0')}-${dd.toString().padStart(2, '0')}`;
  }
  out.optionType = cp === 'C' ? 'C' : 'P';
  const strike = Number(strikeRaw) / 1000;
  out.strike = Number.isFinite(strike) ? strike : null;
  return out;
}

export function optionTypeLabel(optionType: ParsedOccOptionSymbol['optionType']): string {
  if (optionType === 'C') return 'Call';
  if (optionType === 'P') return 'Put';
  return 'Option';
}
